// Loading.stories found within Toploader.stories.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Loading.scss';
import classNames from 'classnames';
export const Spinner = ({size = 250, isVisible = true, fullscreen = false}) => {
  const isFullScreen = fullscreen ? styles.fullscreen : '';
  if (isVisible) {
    return (
      <div className={classNames(styles.spinner, isFullScreen)}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-25 -25 100 100" width={size}>
          <g>
            <path d="M25 0a25 25 0 0 0 0 50" strokeDasharray="79" stroke="#c02025"
              strokeWidth="4" strokeLinecap="round" fill="none">
              <animate id="a1" attributeType="XML" attributeName="stroke-dashoffset"
                from="9" to="76" dur="750ms" begin="0s; a2.end"
                fill="freeze" calcMode="spline" keyTimes="0;1"
                keySplines="0.215, 0.61, 0.355, 1" />
              <animate id="a2" attributeType="XML" attributeName="stroke-dashoffset"
                from="76" to="9" dur="750ms" begin="a1.end"
                fill="freeze" calcMode="spline" keyTimes="0;1"
                keySplines="0.215, 0.61, 0.355, 1" />
              <animateTransform id="a5" attributeType="XML" attributeName="transform"
                type="rotate" from="0 25 25" to="0 25 25" dur="750ms" begin="0; a8.end"
                calcMode="spline" keyTimes="0;1"
                keySplines="0.215, 0.61, 0.355, 1" />
              <animateTransform id="a6" attributeType="XML" attributeName="transform"
                type="rotate" from="0 25 25" to="180 25 25" dur="750ms" begin="a5.end"
                calcMode="spline" keyTimes="0;1"
                keySplines="0.215, 0.61, 0.355, 1" />
              <animateTransform id="a7" attributeType="XML" attributeName="transform"
                type="rotate" from="180 25 25" to="180 25 25" dur="750ms" begin="a6.end"
                calcMode="spline" keyTimes="0;1"
                keySplines="0.215, 0.61, 0.355, 1" />
              <animateTransform id="a8" attributeType="XML" attributeName="transform"
                type="rotate" from="180 25 25" to="360 25 25" dur="750ms" begin="a7.end"
                calcMode="spline" keyTimes="0;1"
                keySplines="0.215, 0.61, 0.355, 1" />
            </path>
            <path d="M25 50a25 25 0 1 0 0-50" strokeDasharray="79" stroke="#777"
              strokeWidth="4" strokeLinecap="round" fill="none">
              <animate attributeType="XML" attributeName="stroke-dashoffset"
                from="9" to="76" dur="750ms" begin="0s; a2.end"
                fill="freeze" calcMode="spline" keyTimes="0;1"
                keySplines="0.215, 0.61, 0.355, 1" />
              <animate attributeType="XML" attributeName="stroke-dashoffset"
                from="76" to="9" dur="750ms" begin="a1.end"
                fill="freeze" calcMode="spline" keyTimes="0;1"
                keySplines="0.215, 0.61, 0.355, 1" />
              <animateTransform attributeType="XML" attributeName="transform"
                type="rotate" from="0 25 25" to="0 25 25" dur="750ms" begin="0; a8.end"
                calcMode="spline" keyTimes="0;1" keySplines="0.215, 0.61, 0.355, 1" />
              <animateTransform attributeType="XML" attributeName="transform"
                type="rotate" from="0 25 25" to="180 25 25" dur="750ms" begin="a5.end"
                calcMode="spline" keyTimes="0;1" keySplines="0.215, 0.61, 0.355, 1" />
              <animateTransform attributeType="XML" attributeName="transform"
                type="rotate" from="180 25 25" to="180 25 25" dur="750ms" begin="a6.end"
                calcMode="spline" keyTimes="0;1" keySplines="0.215, 0.61, 0.355, 1" />
              <animateTransform id="a8" attributeType="XML" attributeName="transform"
                type="rotate" from="180 25 25" to="360 25 25" dur="750ms" begin="a7.end"
                calcMode="spline" keyTimes="0;1" keySplines="0.215, 0.61, 0.355, 1" />
            </path>
            <animateTransform attributeType="XML" attributeName="transform"
              type="rotate" from="0 25 25" to="360 25 25"
              dur="6750ms" repeatCount="indefinite" />
          </g>
        </svg>
      </div>
    );
  } else {
    return null;
  }
};


Spinner.propTypes = {
  size: PropTypes.number,
  isVisible: PropTypes.bool,
};
